import _ from 'lodash'

export default {
  state: {
    starred: [],
    completed: [],
    currentLecture: {},
    page: {},
    course: {},
    user: {},
    lectureUtilityTab: null,
    sideBarLeft: 'lectureList',
    autoplay: false,
    audioAutoplay: false,
    hasAccess: false,
  },
  getters: {
    notListenedAudioComponents(state) {
      if (state.currentLecture.components) {
        return state.currentLecture.components.filter((component) => {
          return (
            _.includes(['audio'], component.type) &&
            !_.get(component, 'listened')
          )
        })
      }

      return []
    },
    notSeenVideoComponents(state) {
      if (state.currentLecture.components) {
        return state.currentLecture.components.filter((component) => {
          return (
            _.includes(['vimeo'], component.type) &&
            !_.get(component, 'watched')
          )
        })
      }

      return []
    },
    firstLecture(state) {
      return _.get(state, 'course.sections[0].lectures[0]')
    },
    isAuthenticated(state) {
      return !_.isEmpty(state.user)
    },
    lectureProgress(state) {
      let sections = _.get(state, 'course.sections')

      if (!sections) {
        return 0
      }

      let lectures = _.flatten(sections.map((section) => section.lectures))
      let lecturesCount = lectures.length
      let completedCount = state.completed.length

      let result = Math.round((completedCount / lecturesCount) * 100)

      if (isNaN(result)) {
        return 0
      }

      return result
    },
  },
  mutations: {
    toggleAutoplay(state) {
      state.autoplay = !state.autoplay
      if (state.autoplay) {
        state.audioAutoplay = false
      }
    },
    toggleAudioAutoplay(state) {
      state.audioAutoplay = !state.audioAutoplay
      if (state.audioAutoplay) {
        state.autoplay = false
      }
    },
    currentLecture(state, lecture) {
      state.currentLecture = lecture
    },
    setSideBarLeft(state, type) {
      if (type === state.sideBarLeft) {
        state.sideBarLeft = null
      } else {
        state.sideBarLeft = type
      }
    },
    toggleUtilityTab(state, type) {
      if (type === state.lectureUtilityTab) {
        state.lectureUtilityTab = null
      } else {
        state.lectureUtilityTab = type
      }
    },
    login(state, user) {
      state.user = user
    },
    starLecture(state, payload) {
      if (payload.is_starred === 1) {
        state.starred = [...state.starred, {
          'lecture_id': payload.id,
        }]
      } else {
        state.starred = state.starred.filter(c => c.lecture_id !== payload.id)
      }
    },
    completeLecture(state, payload) {
      if (payload.is_completed === true) {
        state.completed = [...state.completed, {
          'lecture_id': payload.id,
        }]
      } else {
        state.completed = state.completed.filter(c => c.lecture_id !== payload.id)
      }
    },
    updateLecture(state, payload) {
      let sections = _.chain(state.course.sections)
        .map((section) => {
          return {
            ...section,
            lectures: _.chain(section.lectures)
              .map((lecture) => {
                if (lecture.id === payload.id) {
                  return {
                    ...lecture,
                    ...payload,
                  }
                } else {
                  return lecture
                }
              })
              .sortBy('sort_order')
              .value(),
          }
        })
        .sortBy('sort_order')
        .value()

      state.course = { ...state.course, sections }
    },
    updateSection(state, payload) {
      let index = _.findIndex(state.course.sections, (section) => {
        section.id === payload.id
      })

      state.course.sections[index] = payload
      state.course = { ...state.course, ...state.course.sections }
    },
    processCourseData(state, payload) {
      state.completed = payload.completed
      state.starred = payload.starred
      state.course = payload.course
      state.page = payload.page
      state.user = payload.student
      state.hasAccess = payload.has_access
    },
  },
  actions: {
    fetchLecture({ commit }, payload) {
      let url = `/lecture/${payload}/watch`
      if (
        _.includes(
          ['localhost', 'skyier.test', 'skyier.com'],
          window.location.hostname,
        )
      ) {
        url = `/json/lectures/${payload}`
      }

      return axios.post(url).then(({ data }) => {
        commit('currentLecture', data.lecture)
        return data
      })
    },
    fetchCourse({ commit }, payload) {
      let url = `/${payload}/watch`
      if (
        _.includes(
          ['localhost', 'skyier.test', 'skyier.com'],
          window.location.hostname,
        )
      ) {
        url = `/home/courses/${payload}/watch`
      }

      return axios.post(url).then(({ data }) => {
        commit('processCourseData', data)
        return data
      })
    },
  },
}
